import React from 'react'
import './nav-drop-down.css';
import DropDownItem from './Drop-down-item';
export default function NavDropDown({ array }) {
    return (
        <div className='container'>
            {array.map((product, index) => (
                <DropDownItem
                    key={index}
                    itemName={product.itemName}
                    number={product.number}
                />
            ))}
        </div>
    )
}
